/* =========================================================================
   CUSTOMISATION - Mickael Lorieau
   Ouvre/ferme la bulle d'info des badges premium ("Anti-Twist",
   "Extra Souple"). Sur desktop, l'ouverture au survol est geree en CSS pur
   (:hover / :focus-within sur .pdp-badge-group, voir antitwist-badge.css).
   Ce script gere le CLIC comme secours pour le tactile (mobile / tablette,
   ou aucun survol n'est possible) et la fermeture manuelle.
   Sur mobile, la bulle est deplacee dans <body> et affichee en mode
   "modale" centree (position: fixed) : les cartes produit de la grille
   collection ont un conteneur .image-cont en overflow:hidden qui tronquait
   sinon la bulle (elle debordait de la zone image recadree).
   Ne touche a aucun autre script ou fonctionnalite du theme.
   ========================================================================= */
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function init() {
    document.querySelectorAll('.pdp-badge--info').forEach(function (badge) {
      if (badge.dataset.antitwistBound) return;
      badge.dataset.antitwistBound = 'true';

      var popover = document.getElementById(badge.getAttribute('aria-controls'));
      if (!popover) return;

      var originalParent = popover.parentNode;
      var originalNextSibling = popover.nextSibling;

      function restorePosition() {
        if (popover.parentNode === document.body) {
          if (originalNextSibling) {
            originalParent.insertBefore(popover, originalNextSibling);
          } else {
            originalParent.appendChild(popover);
          }
          popover.classList.remove('antitwist-popover--modal');
        }
      }

      function close() {
        popover.classList.remove('is-open');
        badge.setAttribute('aria-expanded', 'false');
        restorePosition();
      }

      function toggle(e) {
        e.stopPropagation();
        var isOpen = popover.classList.contains('is-open');
        document.querySelectorAll('.antitwist-popover.is-open').forEach(function (p) {
          if (p !== popover) {
            p.classList.remove('is-open');
            p.classList.remove('antitwist-popover--modal');
          }
        });
        if (isOpen) {
          close();
        } else {
          if (isMobile()) {
            document.body.appendChild(popover);
            popover.classList.add('antitwist-popover--modal');
          }
          popover.classList.add('is-open');
          badge.setAttribute('aria-expanded', 'true');
        }
      }

      badge.addEventListener('click', toggle);
      var closeBtn = popover.querySelector('.antitwist-popover__close');
      if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
      document.addEventListener('click', function (e) {
        if (!popover.contains(e.target) && !badge.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
